import { makeObservable, observable, computed, action, reaction } from "mobx";
import { StepState } from "/@/app/views/PlanView/StepState.js";

import { userFlowState } from "/@/app/states/userFlowState.js";

export class SectionState {
    api=null;
    index = 0;
    name;
    steps = [];

    constructor(section, index, api) {
	this.api=api;
        this.index = index;
        this.name = section.name;
        this.expire_block = section.expire_block;

        let idx = 0;
        for (let s of section.steps) {
            this.steps.push(new StepState(s, idx, api));
            idx++;
        }

        makeObservable(this, {
            name: observable,
            steps: observable,
            //
            anyUnfinished: computed,
            allFinished: computed,
            allUnfinished: computed,
            completable: computed,
            //
            sortSteps: action,
        });

        for (let s of this.steps) {
            reaction(() => s.status, (status) => {
                this.sortSteps();
            });
        }
        this.sortSteps();
    }

    sortSteps = () => {
        if (this.disableSort) {
            return;
        }
        let newSteps = this.steps.toSorted(
            (a, b) => {
                return (
                    (
                        (a.status === "complete" ? -1000 : 0)
                        + a.order)
                    -
                    (
                        (b.status === "complete" ? -1000 : 0)
                        + b.order)
                );
            }
        );
        this.steps.replace(newSteps);
    }

    get completable() {
        for (let s of this.steps) {
            if (!s.completable) {
                return false;
            }
        }
        return true;
    }

    get allFinished() {
        for (let s of this.steps) {
            if (s.completable && s.status !== "complete") {
                return false;
            }
        }
        return true;
    }
    get allUnfinished() {
        for (let s of this.steps) {
            if (s.completable && s.status == "complete") {
                return false;
            }
        }
        return true;
    }
    get anyUnfinished() {
        for (let s of this.steps) {
            if (s.completable && s.status === "complete") {
                return true;
            }
        }
        return false;
    }
}


export class SectionListState {
    api=null;
    sections = [];
    subject=null;

    constructor(sectionList,api) {
	this.api=api;
        sectionList = sectionList.toSorted((a, b) => a.order - b.order)
        let idx = 1;
        for (let l of sectionList) {
	    if (l.expire_block) {this.sections.push(l);continue; };
            if (l.steps[0]?.subject && !this.subject) this.subject=l.steps[0].subject;
            l.index = idx;
            this.sections.push(new SectionState(l, idx, api));
            idx++;
        }
        makeObservable(this, {
            sections: observable,
            allFinished: computed,
            anyUnfinished: computed,
            allUnfinished: computed,
            someFinished: computed,
            //
            resetStepStatuses: action,
        })
    }

    resetStepStatuses = () => {
        this.api.request(`cabinet/plan-steps-reset`, {subject:this.subject},{ api_url:'v2'})
	.then((data) => {
            for (let section of this.sections) {
                section.disableSort = true;
                for (let step of section.steps) {
                    step.setStatus('new');
                }
                section.disableSort = false;
                section.sortSteps();
            }
        });
    }

    get allFinished() {
        for (let s of this.sections) {
            if (!s.allFinished) {
                return false;
            }
        }
        return true;
    }
    get allUnfinished() {
        for (let s of this.sections) {
            if (!s.allUnfinished) {
                return false;
            }
        }
        return true;
    }
    get anyUnfinished() {
        for (let s of this.sections) {
            if (s.anyUnfinished) {
                return true;
            }
        }
        return false;
    }

    countSteps() {
        let totalSteps = 0;
        let finishedSteps = 0;
        for (let section of this.sections) {
            for (let step of section.steps) {
                if (!step.completable) {
                    continue;
                }
                if (step.status === "complete") {
                    finishedSteps +=1;
                }
                totalSteps +=1;
            }
        }
        return [finishedSteps, totalSteps]
    }

    get someFinished() {
        const [finishedSteps, totalSteps] = this.countSteps();
        return (finishedSteps > 0 && finishedSteps < totalSteps)
    }
}
